import React, { useState, useEffect } from "react";
import {Platform, StyleSheet, Text, View} from "react-native";

import cardStyles from "./cardStyles";
import CloseIcon from "../../common/dialog/CloseIcon";
import CardUtils from "./CardUtils";
import {cardShadow} from "../../../../styles/shadows";
import AppTheme from "../../AppTheme";
import GuidesIcon from "../../common/icons/more/GuidesIcon";

export default function CoachReviewCard({ controller, data, isSnoozed = false, onSnooze = null }) {
  const [showCard, setShowCard] = useState(false);

  const cardUtils = new CardUtils(controller, data, setShowCard);
  useEffect(() => {
    cardUtils.restoreCard(data.stored_data);
  }, []);

  return !isSnoozed && !showCard ? null : (
    <View style={cardStyles.container}>
      <View style={[cardStyles.card, { minHeight: 86, height: "auto" }]}>
        <CloseIcon
          onPress={(e) => onSnooze(cardUtils, e)}
          color="#2D3142"
          style={cardStyles.closeButton}
        />

        <View style={{ width: "100%" }}>
          <View style={[cardStyles.header, { paddingHorizontal: 0 }]}>
            <GuidesIcon />

            <View style={[cardStyles.headerInfo, { marginLeft: 6 }]}>
              <Text style={cardStyles.title}>Word of the week</Text>
            </View>
          </View>

          <Text style={styles.infoText} >
            {data.text}
          </Text>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    position: "relative",
    backgroundColor: "#FFF",
    borderRadius: 4,
    marginBottom: 8,
    paddingHorizontal: 8,
    marginHorizontal: 2,
    height: 86,
    ...cardShadow,
    elevation: 3,
  },
  content: {
    paddingRight: 24,
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    height: "100%",
  },
  cardInfo: {
    paddingTop: 5,
    display: "flex",
    alignItems: "flex-start",
    flex: 1,
    height: "100%",
  },
  infoHeader: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  infoText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
    flex: 1,
    marginRight: 16,
  },
});